import { Modal, ModalBody, ModalContent, ModalOverlay } from "@chakra-ui/modal";
import KanbanBoard from "components/kanbanBoard/KanbanBoard"
import { getProspects, updateCustomer } from "interfaces/customer";
import { useEffect, useMemo, useState } from "react";
import { useDisclosure } from "@chakra-ui/hooks";
import Card from "components/card";
import CustomerPopUp from "../editCustomer/customerPopUp";
import EditInformationPU from "../editCustomer/components/pop-up/editInformationPU";
import { useNavigate } from "react-router-dom";
import ProspectToCustomerPopUp from "./component/prospectToCustomerPopUp";
import ProspectListView from "./component/ProspectListView";
import { MdViewColumn, MdTableRows } from "react-icons/md";
import CRMMenu from "../list-customers/components/CRMMenu";
import SearchIcon from "components/icons/SearchIcon";

const Kanban = () => {
    const [cards, setCards] = useState(null);
    const [view, setView] = useState<'kanban' | 'list'>('kanban');
    const [search, setSearch] = useState('');
    const { isOpen, onOpen, onClose } = useDisclosure();
    const {
        isOpen: isOpenProspect,
        onOpen: onOpenProspect,
        onClose: onCloseProspect
    } = useDisclosure();
    const [selectedCard, setSelectedCard] = useState(null);
    const [lastCardMoved, setLastCardMoved] = useState(null);
    const [popUpState, setPopUpState] = useState('page');
    const nav = useNavigate();

    const fetchCustomers = async () => {
        const res = await getProspects("");
        if (res) {
            const defaultCards: any = [];
            res.data.forEach((card: any, index: number) => {
                defaultCards.push({
                    id: index + 1,
                    columnId: card.status === "prospect" ? "qualified" : card.status,
                    content: card.company,
                    ...card
                })
            })
            setCards(defaultCards)
        }
    };

    const editCustomer = async (customer: any) => {

        const data = {
            _id: customer._id,
            deliveryTourId: customer.deliveryTourId,
            deliveryAddress: customer.deliveryAddress,
            billingAddress: customer.billingAddress,
            billingEmail: customer.billingEmail,
            billingPeriod: customer.billingPeriod,
            contact: customer.contact,
            company: customer.company,
            customerId: customer.customerId,
            mail: customer.mail,
            notes: customer.notes,
            vatNumber: customer.vatNumber,
            siren: customer.siren,
            phone: customer.phone,
            paymentMethod: customer.paymentMethod,
            displayName: customer.displayName,
            tags: customer.tags,
            status: customer.status,
        };
        await updateCustomer(data);
        // if (res.data) setSaveStatus("saved");
        // else setSaveStatus("error");
    };

    const onColumnDrop = (card: any) => {
        card.status = card.columnId;
        setLastCardMoved(card);
        editCustomer(card);
    }

    const onDragEnd = () => {
        console.log("end", lastCardMoved);
        if (lastCardMoved && lastCardMoved.status === "active")
            onOpenProspect();
    }

    useEffect(() => {
        fetchCustomers();
    }, []);

    const filteredCards = useMemo(() => {
        if (!cards) return cards;
        const query = search.trim().toLowerCase();
        if (!query) return cards;
        return (cards as any[]).filter((card: any) =>
            [card.company, card.displayName, card.contact, card.mail, card.phone]
                .some((field) => field && String(field).toLowerCase().includes(query))
        );
    }, [cards, search]);

    return (
        <div className="relative">
            <ProspectToCustomerPopUp
                isOpen={isOpenProspect}
                onClose={onCloseProspect}
                onClick={() => {
                    nav(`/edit-customer/${lastCardMoved._id}`);
                    onCloseProspect();
                }}
            />
            <Modal isOpen={isOpen} onClose={onClose}>
                <ModalOverlay className="bg-[#000] !opacity-30" />
                <ModalContent className="top-[22vh] !m-auto !w-max !max-w-[85%] md:top-[12vh]">
                    <ModalBody>
                        <Card extra="px-[30px] sm:ml-[168px] sm:mr-[9px] sm:pt-[35px] pb-[40px] xl:max-w-[80%] xl:max-w-7xl flex !z-[1004] xl:mx-auto max-h-[600px] overflow-y-auto">
                            {popUpState === "page" && (
                                <CustomerPopUp
                                    id={selectedCard}
                                    onPageChange={(page: string) =>
                                        setPopUpState(page)
                                    }
                                />
                            )}
                            {popUpState === "edit" && (
                                <EditInformationPU
                                    id={selectedCard}
                                    onPageChange={(page: string) =>
                                        setPopUpState(page)
                                    }
                                />
                            )}
                        </Card>
                    </ModalBody>
                </ModalContent>
            </Modal>
            <div className="flex items-center justify-between gap-3 flex-wrap">
                <CRMMenu path="/kanban" />
                <div className="flex items-center gap-3 mr-5">
                    <div className="flex h-[38px] items-center rounded-xl bg-lightPrimary text-sm text-gray-600 dark:!bg-navy-900 dark:text-white w-[280px]">
                        <SearchIcon />
                        <input
                            type="text"
                            placeholder="Entreprise, mail, téléphone, contact, ...."
                            value={search}
                            onChange={(e) => setSearch(e.target.value)}
                            className="block w-full rounded-full bg-lightPrimary text-base text-navy-700 outline-none dark:!bg-navy-900 dark:text-white"
                        />
                    </div>
                    <div className="flex gap-2">
                        <button
                            className={`h-8 w-8 flex items-center justify-center rounded-md border ${view === 'kanban' ? 'bg-toola-50 text-toola-600 border-toola-300' : 'bg-white text-gray-500 border-gray-300'}`}
                            title="Vue kanban"
                            onClick={() => setView('kanban')}
                        >
                            <MdViewColumn />
                        </button>
                        <button
                            className={`h-8 w-8 flex items-center justify-center rounded-md border ${view === 'list' ? 'bg-toola-50 text-toola-600 border-toola-300' : 'bg-white text-gray-500 border-gray-300'}`}
                            title="Vue liste"
                            onClick={() => setView('list')}
                        >
                            <MdTableRows />
                        </button>
                    </div>
                </div>
            </div>
            {filteredCards && view === 'kanban' && (
                <KanbanBoard
                    cards={filteredCards}
                    onColumnDrop={onColumnDrop}
                    onDragEnded={onDragEnd}
                    onCardClick={(id: string) => {
                        setSelectedCard(id);
                        setPopUpState("page");
                        onOpen();
                    }}
                />
            )}
            {filteredCards && view === 'list' && (
                <ProspectListView
                    cards={filteredCards}
                    onCardClick={(id: string) => {
                        setSelectedCard(id);
                        setPopUpState("page");
                        onOpen();
                    }}
                />
            )}
        </div>
    );
}

export default Kanban;